import { Component, Input } from '@angular/core';
import { CustomCardComponent } from '../custom-card/custom-card.component';

import { customCard } from '../model/customCard';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { PageHeaderComponent } from '../components/page-header/page-header.component';

@Component({
  selector: 'app-cards-list',
  imports: [
    CustomCardComponent,
    CommonModule,
    TranslocoModule,
    PageHeaderComponent,
  ],
  templateUrl: './cards-list.component.html',
  styleUrl: './cards-list.component.scss',
  standalone: true,
})
export class CardsListComponent {
  @Input() cardslist!: customCard[];
  @Input() title?: string;
}
